import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-calendar",
  "use": "icon-cl-calendar-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-calendar\"><path d=\"M4 1.667V3h-.667C2.6 3 2 3.6 2 4.333v9.334C2 14.4 2.6 15 3.333 15h9.334C13.4 15 14 14.4 14 13.666V4.333C14 3.6 13.4 3 12.667 3H12V1.667h-1.333V3H5.333V1.667H4Zm-.667 2.666h9.334v1.333H3.333V4.333Zm0 2.667h9.334v6.666H3.333V7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol